module.exports = __webpack_public_path__ + "img/home-icon.49defc07.svg";